module.exports = __webpack_public_path__ + "static/img/banner_1.5c0387e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_1.jpg
// module id = mh2H
// module chunks = 0